import * as React from "react";
import { ErrorBoundary } from "react-error-boundary";

import logo from "../../../../assets/images/sm/smart-apps-logo-light.png";
import logoDark from "../../../../assets/images/sm/smart-apps-logo-dark.png";
import { ErrorFallback, Loader } from "smart-react";

import TenantForm from "../Components/Forms/TenantForm";
import { useAuth } from "../../Context/AuthContext";
import useIsDark from "../../Components/Theme/useIsDark";

/**
 * Tenant request screen (UI migrated to Tailwind + shadcn, behavior unchanged)
 */
const UserTenant: React.FC = () => {
  const { authLoader } = useAuth();
  const [isLoader, setIsLoader] = React.useState(false);
  const isDark = useIsDark();

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <>
        {(isLoader || authLoader) && (
          <div className="fixed inset-0 z-50 grid place-items-center bg-background/60 backdrop-blur-sm">
            <Loader />
          </div>
        )}

        <div className="tw theme-zinc min-h-screen bg-muted/30 dark:bg-background flex items-center justify-center px-4 py-8">
          <div className="w-full max-w-5xl rounded-2xl border border-border/60 dark:border-border/50 bg-card shadow-none dark:shadow-2xl dark:shadow-black/60 ring-1 ring-inset ring-black/5 dark:ring-white/10 overflow-hidden">
            <div className="grid md:grid-cols-2">
              {/* Left: form side */}
              <div className="order-2 md:order-1 p-8 sm:p-10 md:border-r">
                <div className="mt-6 text-center">
                  <h1 className="!text-[32px] font-semibold !leading-tight !tracking-tight text-foreground">
                    Request an Organization
                  </h1>
                  <p className="mt-1 text-sm text-foreground/80">
                    Submit a request to create your organization
                  </p>
                </div>

                <div className="mt-6">
                  <TenantForm setIsLoader={setIsLoader} />
                </div>
              </div>

              {/* Right: logo side */}
              <div className="order-1 md:order-2 flex items-center justify-center p-8">
                <img
                  src={isDark ? logoDark : logo}
                  className="h-auto w-[15rem] mx-auto"
                  alt={`${process.env.APP_NAME ?? "App"} Logo`}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    </ErrorBoundary>
  );
};

export default UserTenant;
